import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { screens, semantic_colors } from '../../foundation';
import { SectionTitle, SectionTitleProps } from '../section-title';
import { Breadcrumb, BreadcrumbProps } from '../../components/breadcrumb';
export interface PageHeaderProps {
  /** @default false */
  dense?: boolean;
  /** @default false */
  bordered?: boolean;
  /** @default false */
  maxWidth?: boolean;
  /** @deprecated 스펙아웃될 예정입니다. SectionTitle 삽입시 sectionTitleProps를 이용해주세요. */
  children?: React.ReactNode;
  /**
   * [sectionTitleProps](https://storybook.kakaostyle.in/master/pds/?path=/docs/container-sectiontitle--docs)
   * - PageHeader내 SectionTitle 주입이 필요할 경우 SectionTitle Props 정보를 전달하면 children 요소로써 자동 생성됩니다.
   * - SectionTitle의 안전 여백은 PageHeader에서 사용시 자동 0으로 세팅되며, 필요시 SectionTitleProps에서 재정의할 수 있습니다.
   */
  sectionTitleProps?: SectionTitleProps;
  breadcrumbProps?: BreadcrumbProps;
}

export const PageHeader = ({
  dense = false,
  bordered = false,
  maxWidth = false,
  sectionTitleProps,
  breadcrumbProps,
  children,
}: PropsWithChildren<PageHeaderProps>) => {
  return (
    <Header dense={dense} bordered={bordered}>
      {breadcrumbProps && (
        <BreadcrumbContainer dense={dense}>
          <Breadcrumb {...breadcrumbProps} />
        </BreadcrumbContainer>
      )}
      <ContentContainer dense={dense} maxWidth={maxWidth}>
        {sectionTitleProps && <SectionTitle mb={0} {...sectionTitleProps} />}
        {children}
      </ContentContainer>
    </Header>
  );
};

const Header = styled.header<{ dense: boolean; bordered: boolean }>`
  width: 100%;
  ${({ bordered }) => bordered && `border-bottom: 1px solid ${semantic_colors.border.primary}`};
  padding-top: ${({ dense }) => (dense ? 16 : 32)}px;
  overflow-wrap: break-word;
`;

const BreadcrumbContainer = styled.div<{ dense: boolean }>`
  width: 100%;
  padding: 0 ${({ dense }) => (dense ? 16 : 28)}px 12px;
`;

const ContentContainer = styled.div<{ dense: boolean; maxWidth: boolean }>`
  width: 100%;
  max-width: ${({ dense, maxWidth }) => (!dense && maxWidth ? screens.desktop : 'none')};
  margin: ${({ dense, maxWidth }) => (!dense && maxWidth ? '0 auto' : 0)};
  padding: 0 ${({ dense, maxWidth }) => (dense ? 16 : maxWidth ? 0 : 28)}px;
`;
